module.exports = __webpack_public_path__ + "img/xinpinrenmai.0411ce4e.jpg";